import React from "react";

export default function PostFooter() {
  return (
    <footer className="bg-emerald_deep text-bone py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="font-serif text-3xl mb-4"><span className="text-accent">Fitly</span> India</div>
            <p className="text-bone/60 leading-relaxed max-w-sm">Evidence-based fertility nutrition for your conception journey.</p>
          </div>
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase font-semibold text-accent mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[["Home", "/"], ["Blog", "/blog"], ["Fertility Nutrition", "/fertility-nutrition"], ["Consultation", "/consultation"]].map(([label, href]) => (
                <li key={label}><a href={href} className="text-bone/60 hover:text-accent transition-colors text-sm">{label}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase font-semibold text-accent mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-bone/60">
              <li><a href="tel:+919108818369" className="hover:text-accent transition-colors">+91 91088 18369</a></li>
              <li><a href="mailto:fitlyindiahealth@gmail.com" className="hover:text-accent transition-colors">fitlyindiahealth@gmail.com</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-bone/10 pt-8 text-center text-bone/40 text-xs">&copy; {new Date().getFullYear()} Fitly India. All rights reserved.</div>
      </div>
    </footer>
  );
}
